import {isDebugFlagEnabled} from "../helpers/debugFlags";

const CABINET_SNAP_DEBUG_THROTTLE_MS = 700;

let lastCabinetSnapDebugLogTime = 0;

function isCabinetSnapDebugEnabled() {
  return isDebugFlagEnabled(['sqftDebugCabinetSnap', 'debugCabinetSnap']);
}

function formatDebugNumber(value) {
  return Number.isFinite(value) ? Number(value).toFixed(2) : value;
}

function getLineRangeValues(linePoints, orientation) {
  return orientation === 'vertical'
    ? {
      from: Math.min(linePoints.from.y, linePoints.to.y),
      to: Math.max(linePoints.from.y, linePoints.to.y),
    }
    : {
      from: Math.min(linePoints.from.x, linePoints.to.x),
      to: Math.max(linePoints.from.x, linePoints.to.x),
    };
}

function formatLineRange(lineRange) {
  return lineRange
    ? `${formatDebugNumber(lineRange.from)}..${formatDebugNumber(lineRange.to)}`
    : lineRange;
}

function flushCabinetSnapDebugRows(rows, summary = {}) {
  const now = Date.now();

  if (!rows.length || now - lastCabinetSnapDebugLogTime < CABINET_SNAP_DEBUG_THROTTLE_MS) {
    return;
  }

  lastCabinetSnapDebugLogTime = now;
  console.groupCollapsed('[3D cabinet snap debug]', summary);
  console.table(rows.map(row => ({
    ...row,
    movingRange: formatLineRange(row.movingRange),
    targetRange: formatLineRange(row.targetRange),
  })));
  console.groupEnd();
}

export function createCabinetSnapDebugLogger() {
  if (!isCabinetSnapDebugEnabled()) {
    return null;
  }

  const rows = [];

  return {
    addNoLines({movingShape, targetShape, movingLineCount, targetBackLineCount}) {
      rows.push({
        movingShapeId: movingShape.id,
        targetShapeId: targetShape.id,
        movingLineCount,
        targetBackLineCount,
        result: 'rejected:no-lines',
      });
    },

    addOrientationMismatch({movingShape, targetShape, movingLineEntry, targetLineEntry}) {
      rows.push({
        movingShapeId: movingShape.id,
        targetShapeId: targetShape.id,
        movingRole: movingLineEntry.role,
        targetRole: targetLineEntry.role,
        movingOrientation: movingLineEntry.orientation,
        targetOrientation: targetLineEntry.orientation,
        result: 'rejected:orientation-mismatch',
      });
    },

    addLineEvaluation({
      movingLineEntry,
      targetLineEntry,
      orientation,
      movedLineValue,
      targetLineValue,
      snapDelta,
      primaryOverlap,
      orthogonalDelta,
      finalOverlap,
      movedLinePoints,
      targetLinePoints,
    }) {
      rows.push({
        movingRole: movingLineEntry.role,
        targetRole: targetLineEntry.role,
        orientation,
        movingAxis: formatDebugNumber(movedLineValue),
        targetAxis: formatDebugNumber(targetLineValue),
        snapDelta: formatDebugNumber(snapDelta),
        primaryOverlap,
        orthogonalDelta: orthogonalDelta
          ? formatDebugNumber(orthogonalDelta.x + orthogonalDelta.y)
          : null,
        finalOverlap,
        movingRange: getLineRangeValues(movedLinePoints, orientation),
        targetRange: getLineRangeValues(targetLinePoints, orientation),
        result: finalOverlap ? 'candidate' : 'rejected:no-overlap',
      });
    },

    flush(summary) {
      flushCabinetSnapDebugRows(rows, summary);
    },
  };
}
